import * as types from './mutation-types'
import * as currencyTypes from './modules/currency/mutation-types'
import * as userTypes from './modules/user/mutation-types'
import * as companyTypes from './modules/company/mutation-types'
import * as preferencesTypes from './modules/settings/preferences/mutation-types'
import * as taxTypeTypes from './modules/settings/tax-type/mutation-types'
import * as itemTypes from './modules/item/mutation-types'
import * as paymentModes from './modules/payment/mutation-types'
import * as stakeholderTypes from './modules/profile/stakeholder/mutation-types'
import * as financialFacilityTypes from './modules/profile/financial-facility/mutation-types'
import * as businessTypes from './modules/profile/business/mutation-types'
import * as documentTypes from './modules/documentType/mutation-types'
import * as ContactTypes from './modules/settings/contact/mutation-types'
import * as userGuideTypes from './modules/user-guide/mutation-types'
export default {
  bootstrap ({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/bootstrap').then((response) => {
        commit('company/' + companyTypes.BOOTSTRAP_COMPANIES, response.data.companies)
        commit('company/' + companyTypes.SET_SELECTED_COMPANY, response.data.company)
        commit('currency/' + currencyTypes.BOOTSTRAP_CURRENCIES, response.data)
        commit('currency/' + currencyTypes.SET_DEFAULT_CURRENCY, response.data)
        commit('user/' + userTypes.BOOTSTRAP_CURRENT_USER, response.data.user)

        commit('user/' + userTypes.BOOTSTRAP_ACCOUNT_TYPES, response.data.account_types)
        commit('user/' + userTypes.BOOTSTRAP_DEFAULT_ACCOUNT, response.data.default_account)

        commit('user/' + userTypes.BOOTSTRAP_ROLE_TYPES, response.data.role_types)
        commit('user/' + userTypes.BOOTSTRAP_DEFAULT_ROLE, response.data.default_role)

        commit('user/' + userTypes.BOOTSTRAP_STATUS_TYPES, response.data.status_types)
        commit('user/' + userTypes.BOOTSTRAP_DEFAULT_STATUS, response.data.default_status)

        commit('user/' + userTypes.BOOTSTRAP_DEFAULT_COUNTRY, response.data.default_country)


        commit('taxType/' + taxTypeTypes.BOOTSTRAP_TAX_TYPES, response.data.taxTypes)
        commit('preferences/' + preferencesTypes.SET_MOMENT_DATE_FORMAT, response.data.moment_date_format)
        commit('preferences/' + preferencesTypes.SET_LANGUAGE_FORMAT, response.data.default_language)
        commit('item/' + itemTypes.SET_ITEM_UNITS, response.data.units)
        commit('payment/' + paymentModes.SET_PAYMENT_MODES, response.data.paymentMethods)
        if (response.data.stakeholders) {
          commit('stakeholder/' + stakeholderTypes.SET_STAKEHOLDERS, response.data.stakeholders)
        }
        if (response.data.contacts) {
          commit('contact/' + ContactTypes.SET_CONTACTS, response.data.contacts)
        }
        
        if (response.data.financialfacilities){
          commit('financialFacility/' + financialFacilityTypes.SET_FINANCIAL_FACILITIES, response.data.financialfacilities)
        }
        if (response.data.business){
          commit('business/' + businessTypes.SET_BUSINESS, response.data.business)
        }
        commit('documentType/' + documentTypes.BOOTSTRAP_PREPAYMENT_DOCUMENTTYPES, response.data.preypaymentDocumentTypes, { root: true })
        commit('documentType/' + documentTypes.BOOTSTRAP_INVOICE_DOCUMENTTYPES, response.data.invoiceDocumentTypes, { root: true })
        commit('documentType/' + documentTypes.BOOTSTRAP_PO_DOCUMENTTYPES, response.data.poDocumentTypes, { root: true })
        commit('documentType/' + documentTypes.BOOTSTRAP_PROFILE_DOCUMENTTYPES, response.data.profileDocumentTypes, { root: true })
        commit('documentType/' + documentTypes.BOOTSTRAP_PROCESS_DOCUMENTTYPES, response.data.processDocumentTypes, { root: true })
        

        if (response.data.profileDocuments) {
          commit('documentType/' + documentTypes.PROFILE_DOCUMENTS, response.data.profileDocuments, { root: true })
        }
        if (response.data.default_account.name=='super-admin' && response.data.userGuides){
          commit('userGuide/' + userGuideTypes.SET_USER_GUIDES, response.data.userGuides, { root: true })
        }
        if (response.data.default_account.name == 'supplier' && response.data.userGuides) {
          commit('userGuide/' + userGuideTypes.SET_VIEW_USER_GUIDE, response.data.userGuides, { root: true })
        }
        
        commit(types.UPDATE_APP_LOADING_STATUS, true)
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
